import { Component, Input } from '@angular/core';
import { environment } from '@environment';
import { BaseComponent } from '@core/components/base/base.component';

@Component({
  selector: 'app-brand-rating',
  templateUrl: './brand-rating.component.html',
  styleUrls: ['./brand-rating.component.scss'],
  standalone: true
})
export class BrandRatingComponent extends BaseComponent {

  constructor() {
    super();
  }

  @Input() isRepeatUser = false;
  DEPLOY_URL = environment.DEPLOY_URL;

}
